import {
  type AhaEditor,
  type CustomElement,
  Tool,
  type ToolArgsWithController,
} from '@aha-app/aha-editor-v2';
import icon from 'images/icons/open-whiteboard.svg?inline';
import { whiteboardControllerForEditor } from '../EmbeddedWhiteboardControllersPluginFactory';

function getOriginalWhiteboardUrl(
  ahaEditor: AhaEditor,
  element: CustomElement | undefined
): string | undefined {
  const controller = whiteboardControllerForEditor(ahaEditor, element);

  return controller?.originalWhiteboardUrl();
}

class ToolOpenOriginalWhiteboard extends Tool {
  static toolName = 'Open original';
  static iconSvg = icon;

  static available({ controller, element }: ToolArgsWithController): boolean {
    return Boolean(getOriginalWhiteboardUrl(controller.ahaEditor, element));
  }

  static action({ controller, element }: ToolArgsWithController): void {
    const url = getOriginalWhiteboardUrl(controller.ahaEditor, element);
    if (url) {
      window.open(url, '_blank');
    }
  }
}

export default ToolOpenOriginalWhiteboard;
